import $ from 'jquery';

$(document).ready(function() {
  if (!$('#licennse-admin-licensees').length) return;

  $('#licennse-admin-licensees').DataTable({
    paging: true,
  });

  $('#show-licensees').on('click', function() {
    $('#licensees-table').toggle();
  });

  $('#selected-licensees').on('click', 'li', function() {
    if (this.getAttribute("id") === 'keep') { return; }

    const table = $('#licennse-admin-licensees').DataTable();
    const deleteId = this.getAttribute("data-deleteId");
    const row = table.$('#licensee-ownership-' + deleteId);
    row.prop("checked", false);
    this.remove();
  });

  $('#licennse-admin-licensees').on('click', 'input[type="checkbox"]', function() {
    const licId = this.getAttribute("data-licenseeId");
    const licName = this.getAttribute("data-licenseeName");

    if (this.checked) {
      const li = document.createElement('li');
      li.id = 'selected-licensee-' + licId;
      li.setAttribute('data-deleteId', licId);

      const btn = document.createElement('button');
      btn.className = 'btn btn-danger btn-xs';
      btn.style.margin = '3px';
      btn.textContent = 'Remove';
      li.appendChild(btn);

      li.appendChild(document.createTextNode(' ' + licName));

      const hidden = document.createElement('input');
      hidden.type = 'hidden';
      hidden.name = 'licensee_admin[licensee_ids][]';
      hidden.value = licId;
      li.appendChild(hidden);

      document.getElementById('selected-licensees').appendChild(li);
    } else {
      $('#selected-licensee-' + licId).remove();
    }
  });
});
